import React, { useEffect, useState } from 'react';
import { Grid, Header, Icon, Container, Input } from 'semantic-ui-react'
import { Accordion, AccordionTab } from 'primereact/accordion';
import { useToasts } from 'react-toast-notifications';
import { ConnectWS } from '../../../../ConnectWS';
import { getTabByFiltr, loadingShow } from '../../../../myfunctions';
import { Markup } from 'interweave';
import useWindowDimensions from '../../../../hooks/useWindowDimensions';


function Faq({ hiddenHeader }) {

  const [loading, setloading] = useState(false);// eslint-disable-line no-unused-vars
  const [faqData, setfaqData] = useState({ current: null, data: null });
  const { addToast } = useToasts();
  const { width, height } = useWindowDimensions();// eslint-disable-line no-unused-vars

  useEffect(() => {
    getFaq()
    return () => { }; // use effect cleanup to set flag false, if unmounted
  }, [])// eslint-disable-line react-hooks/exhaustive-deps


  function getFaq() {
    setloading(true)
    ConnectWS("/data/getFaq", null, {}, function (response, logout) {
      if (logout === 1) {
        addToast("Brak zalogowanego użytkownika", { appearance: 'info' });

      } else if (response && response.status && Number(response.status) === 200) {
        setfaqData({ current: response.data, data: response.data })
      } else {
        if (logout === 101) {
          addToast(response, { appearance: 'info' });
        } else if (logout === 102) {
          addToast(response, { appearance: 'warning' });
        } else {
          addToast(response, { appearance: 'error' });
        }
      }
      setloading(false)

    });
  }


  return (
    <Grid stackable >
      <Grid.Row >

        <Grid.Column width={16} >
          <Container >
            {hiddenHeader ? "" :
              <Header as={width < 800 ? "h4" : "h2"} style={{ marginTop: 10, marginBottom: 30 }} textAlign={width < 800 ? "left" : "center"}>
                <Icon name='book' color="red" />
                <Header.Content>FAQ – często zadawane pytania</Header.Content>
              </Header>
            }
            <Input fluid style={{ marginTop: 10, marginBottom: 10 }} icon='search' onChange={(e, d) => getTabByFiltr(d.value, faqData, setfaqData, 10000)} placeholder={"Szukaj... min 3 znaki"} />
            {loading ? loadingShow() :
              <Accordion activeIndex={0} className={hiddenHeader ? "" : 'afaq'}>
                {faqData.current ? faqData.current.map((row, i) => <AccordionTab key={i} header={row.name}>
                  <Markup content={row.description} />
                </AccordionTab>) : ""}
              </Accordion>
            }
          </Container>
        </Grid.Column>


      </Grid.Row>
    </Grid>

  )
}

export default Faq;



